import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  FlexBox,
  Text,
  Label,
  Avatar,
  Button,
  Input,
  RatingIndicator,
  MessageStrip,
} from '@ui5/webcomponents-react';

function GuestRatingCard({ locationUUID }) {
  const [rating, setRating] = useState(0);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);

  const handleRatingChange = (e) => {
    // UI5 RatingIndicator fires change with detail.value
    var val = Number(e.detail ? e.detail.value : e.target.value) || 0;
    setRating(val);

    if (val >= 5) {
      // Show contact form for 5-star ratings
      setShowContactForm(true);
    } else if (val > 0) {
      // Less than 5 — notify host immediately
      setShowContactForm(false);
      fetch('/api/V1.1/qr/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616',
          task: 'submitGuestContact',
          uuid: locationUUID,
          rating: val,
          email: '',
          phone: '',
        }),
      }).catch(() => {});
      setSubmitted(true);
    }
  };

  const handleSubmit = () => {
    if (!email) return;
    setSubmitting(true);

    fetch('/api/V1.1/qr/users', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        appToken: 'qRt0ke4bRLCp5p4d5z1Cc6n616',
        task: 'submitGuestContact',
        uuid: locationUUID,
        rating: 5,
        email: email,
        phone: phone,
      }),
    })
      .then(() => setSubmitted(true))
      .catch(() => setSubmitted(true))
      .finally(() => setSubmitting(false));
  };

  // Already submitted
  if (submitted) {
    return (
      <Card className="grid-card">
        <CardHeader
          avatar={<Avatar icon="favorite" colorScheme="Accent6" />}
          titleText="Thank You!"
          subtitleText="We appreciate your feedback"
        />
        <div className="card-body">
          <FlexBox direction="Column" alignItems="Center" style={{ padding: '1rem 0' }}>
            {rating >= 5 ? (
              <MessageStrip design="Positive" hideCloseButton>
                Thanks! We'll keep you in the loop for our specials.
              </MessageStrip>
            ) : (
              <Text>Thanks for letting us know — your host has been notified and will be in touch shortly.</Text>
            )}
          </FlexBox>
        </div>
      </Card>
    );
  }

  return (
    <Card className="grid-card">
      <CardHeader
        avatar={<Avatar icon="favorite" colorScheme="Accent6" />}
        titleText="How's your stay going?"
        subtitleText="Let us know so we can make it great"
      />
      <div className="card-body">
        <FlexBox direction="Column" alignItems="Center" className="rating-container">
          <RatingIndicator
            value={rating}
            onChange={handleRatingChange}
            max={5}
            style={{ fontSize: '2rem' }}
          />

          {showContactForm && (
            <FlexBox direction="Column" style={{ width: '100%', marginTop: '1rem', gap: '0.75rem' }}>
              <MessageStrip design="Positive" hideCloseButton style={{ marginBottom: '0.5rem' }}>
                Glad you're loving it! Share your info for 10% off your next stay.
              </MessageStrip>

              <div>
                <Label className="info-label">Email</Label>
                <Input
                  type="Email"
                  value={email}
                  onInput={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  style={{ width: '100%' }}
                />
              </div>

              <div>
                <Label className="info-label">Phone (optional)</Label>
                <Input
                  type="Tel"
                  value={phone}
                  onInput={(e) => setPhone(e.target.value)}
                  placeholder="(555) 123-4567"
                  style={{ width: '100%' }}
                />
              </div>

              <Button
                design="Emphasized"
                onClick={handleSubmit}
                disabled={submitting || !email}
                style={{ marginTop: '0.5rem' }}
              >
                {submitting ? 'Submitting...' : 'Get 10% Off'}
              </Button>
            </FlexBox>
          )}
        </FlexBox>
      </div>
    </Card>
  );
}

export default GuestRatingCard;
